<template>
  <div class="lpagination" v-show="!value">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :hide-on-single-page="value"
      :current-page="currentPage"
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :page-sizes="[30, 50, 100, 200]"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: ['total', 'currentPage', 'pageSize'],
  data () {
    return {
      value: false
    }
  },
  watch: {
    total (newVal) {
      if (newVal === 0) {
        this.value = true
      } else {
        this.value = false
      }
    }
  },
  created () {
    // this.handleSizeChange()
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.lpagination {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0px 20px 30px;
}
::v-deep .el-pager li.number,
.el-pagination ::v-deep button {
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-left: 20px;
  color: #4e555b;
  /*font-size: 400 !important;*/
  text-align: center;
}
::v-deep .el-pager li.active,
::v-deep .el-pager li:hover,
.el-pagination ::v-deep button:hover {
  // border: 1px solid #fff;
  border-radius: 4px;
  // background-color: #276cff;
  color: #5c90ff;
  /*font-size: 400 !important;*/
}
.el-pagination ::v-deep .btn-prev,
.el-pagination ::v-deep .btn-next {
  padding: 0;
}
</style>
